import script from "./DetalharReceitaGeral.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalharReceitaGeral.vue?vue&type=script&setup=true&lang=js"

import "./DetalharReceitaGeral.vue?vue&type=style&index=0&id=36cef4ad&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36cef4ad"]])

export default __exports__